/**
 * @author Kajabi, LLC <info@kajabi.com>
 * @license MIT
 */
import { createPlugin } from "@backstage/core";

export const envVarCollatorPlugin = createPlugin({
  id: "env-var-collator",
});

export const featureFlagCollatorPlugin = createPlugin({
  id: "feature-flag-collator",
});

export const codeCollatorPlugin = createPlugin({
  id: "code-collator",
});
